import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { UserAccountPropTypes } from '@zocdoc-frontend-common/state-user-account/constants';
import { Metrics } from '@zocdoc/frontend-metrics';
import NotificationMenuView from './NotificationMenuView';

const Container = styled.div`
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;

    ${(p) => {
        if (p.usePatientHomeV3Variant) {
            return `
                    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
                `;
        }
    }}
`;

export default class NotificationMenuContainer extends Component {
    static propTypes = {
        count: PropTypes.number.isRequired,
        loginState: UserAccountPropTypes.loginState.isRequired,
        isOpen: PropTypes.bool,

        onNotificationDropdownClick: PropTypes.func,
        onNotificationClick: PropTypes.func,
        onUpcomingAppointmentClick: PropTypes.func,
        onSeeAllNotificationsClick: PropTypes.func,
        onClickSoftLoggedInLogin: PropTypes.func,

        // Search Bar V2 related prop
        shouldShowNewSearchHeader: PropTypes.bool,
    };

    static defaultProps = {
        isOpen: false,
        usePatientHomeV3Variant: false,
    };

    state = {
        isOpen: false,
    };

    render() {
        const isOpen = this.state.isOpen || this.props.isOpen;
        const { usePatientHomeV3Variant } = this.props;
        return (
            <Container usePatientHomeV3Variant={usePatientHomeV3Variant}>
                <Metrics component="Notifications">
                    <NotificationMenuView
                        {...this.props}
                        closeDropdown={this.closeDropdown}
                        isOpen={isOpen}
                        toggleDropdown={this.toggleDropdown}
                    />
                </Metrics>
            </Container>
        );
    }

    closeDropdown = () => {
        this.setState({
            isOpen: false,
        });
    };

    toggleDropdown = () => {
        const { isOpen } = this.state;
        if (!isOpen) {
            this.props.onNotificationDropdownClick();
        }
        this.setState({
            isOpen: !isOpen,
        });
    };
}
